import { motion } from 'framer-motion';
import AnimatedSection, { staggerContainer, fadeUpVariant } from './AnimatedSection';
import './WhoWeServe.scss';

const audiences = [
  {
    title: 'Traders',
    desc: 'Access upfront capital for every shipment. Stop waiting on payments that delay your next trade.',
    pill: 'Upfront Capital',
  },
  {
    title: 'Brokers',
    desc: 'Reliable loads, faster payments, better partners. Build a book of business backed by institutional infrastructure.',
    pill: 'Reliable Partners',
  },
  {
    title: 'Credit Professionals',
    desc: 'Institutional-grade trade credit infrastructure. Structured exposure to African freight with real execution oversight.',
    pill: 'Institutional Grade',
  },
];

export default function WhoWeServe({ compact = false }) {
  return (
    <section className="who-we-serve">
      <div className="container">
        {!compact && (
          <AnimatedSection className="who-we-serve__header">
            <p className="who-we-serve__label">Who We Serve</p>
            <h2 className="who-we-serve__title">Built for the entire trade value chain</h2>
          </AnimatedSection>
        )}

        <motion.div
          className="who-we-serve__cards"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {audiences.map(({ title, desc, pill }) => (
            <motion.div key={title} className="who-we-serve__card" variants={fadeUpVariant}>
              <h3 className="who-we-serve__card-title">{title}</h3>
              <p className="who-we-serve__card-desc">{desc}</p>
              <span className="who-we-serve__pill">{pill}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
